export const defaultMaterialMeanTemplate = (baseDate: Date = new Date()) => `{
  "referenceId": "TRUCK-REF-001",
  "registrationNumber": "AA-123-BB",
  "meanType": "TRUCK",
  "meanSubtype": "FTL_LTL",
  "allocationDate": "${baseDate.toISOString()}",
  "dimensions": {
    "length": {
      "value": 1360,
      "unit": "CMT"
    },
    "width": {
      "value": 255,
      "unit": "CMT"
    },
    "height": {
      "value": 400,
      "unit": "CMT"
    },
    "volume": {
      "value": 90,
      "unit": "MTQ"
    }
  },
  "pieces": [
    {
      "uri": "urn:bol:piece:pce-001"
    }
  ],
  "externalReferences": [
    {
      "externalReferenceType": "PROVIDER_ID",
      "reference": "MM-2026-001"
    }
  ]
}`;
